import { all } from "redux-saga/effects";

import { loadModeSessionsWatcher, loadModeEventsWatcher } from "./modes";

export function* rootSaga() {
    yield all([
        loadModeSessionsWatcher(),
        loadModeEventsWatcher(),
    ]);
}